import React from "react";
import Hero from "../Components/Hero";
import About from "../Components/About";
import Clients from "../Components/Clients/Clients";

const Home = () => {

  return (
    <>
      <Hero />
      <About />
      <Clients />
    </>
  );
};

export default Home;
